import React from 'react';
import { getTemplate } from 'TRANSLATION';
const Content = getTemplate('hint/HNWI');

export default function Hnwi() {
  return <Content />;
}
